import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import GoogleAuthCallback from "@/components/site/GoogleAuthCallback";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import StyleShowcase from "@/components/site/StyleShowcase";
import Process from "@/components/site/Process";
import Pricing from "@/components/site/Pricing";
import FAQ from "@/components/site/FAQ";
import Testimonials from "@/components/site/Testimonials";
import ContactForm from "@/components/site/ContactForm";
import Footer from "@/components/site/Footer";
import UploadPage from "@/pages/UploadPage";
import OwnerPhotosPage from "@/pages/OwnerPhotosPage";
import OwnerLoginPage from "@/pages/OwnerLoginPage";
import FilmPage from "@/pages/FilmPage";
import AdminRequestsPage from "@/pages/AdminRequestsPage";
import AdminNotesPage from "@/pages/AdminNotesPage";
import WatchPage from "@/pages/WatchPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import MusicPlayer from "@/components/site/MusicPlayer";

const Home = () => {
  return (
    <div data-testid="landing-page" className="relative">
      <Header />
      <main>
        <Hero />
        <StyleShowcase />
        <Process />
        <Pricing />
        <Testimonials />
        <FAQ />
        <ContactForm />
      </main>
      <Footer />
      <MusicPlayer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <Toaster
        position="top-center"
        theme="dark"
        toastOptions={{
          style: {
            background: "rgba(20, 19, 17, 0.95)",
            color: "#F5F0E8",
            border: "1px solid rgba(212, 175, 55, 0.3)",
            backdropFilter: "blur(14px)",
          },
        }}
      />
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </div>
  );
}

function AppRouter() {
  const location = useLocation();
  // Returning from Google sign-in: exchange session_id before any route renders
  if (location.hash?.includes("session_id=")) return <GoogleAuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/upload/:token" element={<UploadPage />} />
      <Route path="/photos/:token" element={<OwnerPhotosPage />} />
      <Route path="/owner" element={<OwnerLoginPage />} />
      <Route path="/owner/reset" element={<ResetPasswordPage />} />
      <Route path="/admin" element={<AdminRequestsPage />} />
      <Route path="/admin/notes" element={<AdminNotesPage />} />
      <Route path="/watch/:token" element={<WatchPage />} />
      <Route path="/film/:token" element={<FilmPage />} />
    </Routes>
  );
}

export default App;
